import _ from 'lodash'

export default {
  methods: {
    isValidNumber(value) {
      if(value === null || value === undefined)
        return false
      if(isNaN(parseFloat(value)))
        return false
      return true
    },

    isEmptyString(value) {
      if(value === null || value === undefined)
        return true
      var text = ('' + value).trim()

      return text == ''
    },

    // Really simply email validation
    // Only use for warnings, the server will handle final validation
    isValidEmail(email) {
      if(email === null || email === undefined)
        return false

      var address = ('' + email).trim().toLowerCase()
      if(address == '')
        return false

      // JB: 28/6/24 - Return false if the email ends in a dot
      // Technically it's correct and follows the specs, but AWS SES throws errors for recipients ending with a dot
      if(address.endsWith('.'))
        return false

      // Regex based on code from below which is based on RFC 2822
      // https://gist.github.com/gregseth/5582254

      var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/
      return regex.test(address)
    },

    // Sanitize an email address
    sanitizeEmail(email) {
      if(email === null || email === undefined)
        return ''

      var address = ('' + email).trim()

      // Remove unicode characters and replace with closest ascii equivalent
      address = _.deburr(address)
      address = String(address).normalize('NFKD')

      const charMap = {
        '\u2018': "'",  // left single quote
        '\u2019': "'",  // right single quote
        '\u201C': '"',  // left double quote
        '\u201D': '"',  // right double quote
        '\u2012': '-',  // figure dash
        '\u2013': '-',  // en dash
        '\u2014': '-',  // em dash
        '\u2026': '...',// ellipsis
        '\u00A0': ' ',  // non-breaking space
      };

      // Remap certain unicode characters to their ascii equivalent
      address = address.replace(/[\u2018\u2019\u201C\u201D\u2012\u2013\u2014\u2026\u00A0]/g, m => charMap[m])

      return address
    }
  }
}